import React, { useEffect, useRef, useState } from "react";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import CoursePaymentForm from "./CoursePaymentForm";
import { BaseUrl } from "../../../../Actions/Base";

// const stripePromise = loadStripe("pk_test_51PiHuIIAQLPiIZKHYsC2Ey7spxTxK6uolxARiYy1YDii95504gL2hwae2bn29pAnwnIXOzGdAJsJc9WBXhPwoO3a00ElDFGz2e");
const stripePromise = loadStripe("pk_test_51R43UFD3cD5p3COSu4hXSozwMkHBbPple59QTIm1kg1O5bgGsJFPrg1cB4nK4vP0twcY7ZawmNaMaLtkbIMMbWS200udy4SIBx");

const CoursePaymentMethod = ({Package,
    Installment,
    setSuccess,
    EnrollmentData,
    PayPalButton,
    PaypalBtnRef,
    StudentImage,
    handleEnrollmentSuccess,
    UserInformation,
    dispatch,
    LatestLicense,
    setErr,
    Err,
    totalPayment}) =>{
    const [clientSecret, setClientSecret] = useState("");
    const [googleClientSecret, setGoogleClientSecret] = useState(null);

    console.log("totalPayment in CoursePaymentMethod is:",totalPayment)

    useEffect(() => {
        const fetchClientSecret = async () => {
            try {
                const response = await fetch(`${BaseUrl}/api/banksetup-intent`, {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                });
    
                const data = await response.json();
                console.log("Received clientSecret:", data.clientSecret);
    
                if (data.clientSecret) {
                    setClientSecret(data.clientSecret);
                } else {
                    console.error("Invalid clientSecret received:", data);
                }
            } catch (error) {
                console.error("Error fetching clientSecret:", error.message);
            }
        };
    
        fetchClientSecret();
    }, []);
    


    useEffect(() => {
        const createPaymentIntent = async () => {
            try {
                const response = await fetch(`${BaseUrl}/api/create-googleandapplepayment-intent`, {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ amount: 50 }), // 50 CAD
                });
                const data = await response.json();
                console.log("Received GoogleClientSecret:", data.clientSecret); // Debugging log

                setGoogleClientSecret(data.clientSecret);
            } catch (error) {
                console.error("Error creating payment intent:", error);
            }
        };

        createPaymentIntent();
    }, []); // Empty dependency array ensures it runs only once when the component mounts


    // Prevent rendering <Elements> until clientSecret is available
    if (!clientSecret) {
        return <p>Loading payment form...</p>;
    }

    return (
        <Elements stripe={stripePromise}  options={{
            clientSecret,
            appearance: { theme: 'stripe' },
            // 👇 Stripe will use this to prefill or configure PaymentElement steps
            paymentMethodCreation: 'manual',
          }}>
            <CoursePaymentForm 
                clientSecret={clientSecret}
                setClientSecret={setClientSecret}
                setGoogleClientSecret={setGoogleClientSecret}
                googleClientSecret={googleClientSecret}
                handleEnrollmentSuccess={handleEnrollmentSuccess}
                setSuccess={setSuccess}
                Package={Package}
                Installment={Installment}
                PayPalButton={PayPalButton}
                PaypalBtnRef={PaypalBtnRef}
                EnrollmentData={EnrollmentData}
                StudentImage={StudentImage}
                LatestLicense={LatestLicense}
                currency="USD"
                setErr={setErr}
                Err={Err}
                UserInformation={UserInformation}
                dispatch={dispatch}
                totalPayment={totalPayment}
            />
        </Elements>
    )
}

export default CoursePaymentMethod;
